// EmptyState.tsx
import { LucideIcon } from "lucide-react";
export function EmptyState({
  icon: Icon, title, description, action,
}: { icon: LucideIcon; title: string; description?: string; action?: React.ReactNode }) {
  return (
    <div className="text-center py-14 px-6">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-surface-100 mb-4">
        <Icon className="w-7 h-7 text-surface-400" />
      </div>
      <h3 className="text-lg font-semibold text-surface-900">{title}</h3>
      {description && <p className="mt-1.5 text-sm text-surface-500 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}